import { useRef, useState, useCallback } from "react";
import toast from "react-hot-toast";
import { shareOrDownloadInvoiceImage } from "../utils/invoiceShareImage.js";

/**
 * Hook para generar y compartir captura PNG de una factura.
 * @param {object|null} invoice
 */
export function useInvoiceShareImage(invoice) {
  const shareCardRef = useRef(null);
  const [sharing, setSharing] = useState(false);

  const shareInvoiceImage = useCallback(async () => {
    if (!invoice || !shareCardRef.current) {
      toast.error("No hay factura para compartir");
      return;
    }
    setSharing(true);
    try {
      const filename = `factura_${invoice.invoiceNumber || "detalle"}.png`;
      const result = await shareOrDownloadInvoiceImage(shareCardRef.current, filename);
      if (result === "shared") {
        toast.success("Imagen lista para enviar al cliente");
      } else {
        toast.success("Imagen descargada — puedes enviarla por WhatsApp");
      }
    } catch (err) {
      if (err?.name === "AbortError") return;
      console.error(err);
      toast.error("No se pudo generar la imagen de la factura");
    } finally {
      setSharing(false);
    }
  }, [invoice]);

  return { shareCardRef, sharing, shareInvoiceImage };
}
